const SocialLinks = () => {
  return (
    <section className="py-16 bg-[#FAF8F5]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-3xl p-12 shadow-lg border-2 border-dashed border-[#8B9D7C]">
          <div className="text-center">
            <h3 className="text-3xl font-serif text-[#2D5016] mb-4">
              Seguici per Offerte Esclusive
            </h3>
            <p className="text-gray-600 mb-8">
              Non perdere le nostre promozioni speciali su Meta e TikTok
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-8 py-4 bg-[#1877F2] text-white rounded-full hover:bg-[#0d65d9] transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                <i className="ri-facebook-fill text-2xl"></i>
                <span className="font-medium">Seguici su Meta</span>
              </a>

              <a
                href="https://www.tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-8 py-4 bg-black text-white rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                <i className="ri-tiktok-fill text-2xl"></i>
                <span className="font-medium">Seguici su TikTok</span>
              </a>
            </div>

            <p className="text-sm text-gray-500 mt-6">
              <i className="ri-gift-line mr-1"></i>
              Offerte esclusive e codici sconto solo per i nostri follower
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Vuoi promuovere un prodotto specifico? Contattaci per campagne personalizzate
          </p>
          <a
            href="/contatti"
            className="inline-flex items-center text-[#2D5016] font-medium hover:underline cursor-pointer"
          >
            Richiedi Informazioni
            <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialLinks;